if (typeof Stickyfill !== 'undefined') {
  var profile_sidebar = document.querySelectorAll('.profile-sidebar-wrapper');
  Stickyfill.add(profile_sidebar);
}
